import {
  Button,
  Input,
  Text,
  HStack,
  Flex,
  Box,
  Spinner,
  ModalFooter,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerCloseButton,
  Tooltip,
} from "@chakra-ui/react";
import { useState, useEffect, useContext, useRef } from "react";
import { handleDownloadExcel, transformData } from "./utils/functions";
import CommentDrawer from "../../CommentDrawer/CommentDrawer";
import { AppContext } from "AppProvider/AppContext";
import { appRequest } from "routes";
import FileViewer from "components/common/FileViewerPdfAndImage/FileViewer";
import {
  FiChevronLeft,
  FiChevronRight,
  FiChevronsRight,
  FiDownload,
} from "react-icons/fi";
import { MdEmail } from "react-icons/md";
import MailModal from "./MailModal";
import DynamicTableForm from "./DynamicTableForm";
import SaveDocumentModal from "../../AddComentModal/SaveDocumentModal";

const CurbayMedicineCustomModal = ({
  file,
  getData,
  isDisabled = false,
  selectedRows,
  setSelectedRows,
  commentModel,
  setCommentModel,
  name,
  open,
  close,
  values,
}: any) => {
  const { toastNotify, accountDetails, workFlowData } = useContext(AppContext);
  const tableRef = useRef<any>(null);
  const [finalResults, setFinalResults] = useState<any>([]);
  const [fetchFileLoader, setFetchFileLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [sample, setSample] = useState({
    url: "",
    file: null,
    type: null,
    buffer: null,
  });
  const [fieldName, setFieldName] = useState<string[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [inputValue, setInputValue] = useState(currentPage.toString());
  const [transformedData, setTransformedData] = useState<any[]>([]);
  const [fileData, setFileData] = useState<any>(null);
  const [openSaveModal, setOpenSaveModal] = useState<any>({
    data: null,
    open: false,
  });
  const [currentTotalDataCount, setCurrentTotalDataCount] = useState(0);
  const [isMailOpen, setIsMailOpen] = useState<boolean>(false);

  useEffect(() => {
    if (Array.isArray(values)) {
      setTransformedData(values[values?.length - 1]?.values);
    } else {
      setTotalPages(values?.values?.pageCount || 0);

      if (Array.isArray(values?.values?.results)) {
        let data = transformData(values?.values?.results);

        const groupedData = data.reduce(
          (acc: any[], { fieldName, rows, pageIndex }: any) => {
            // Ensure `pageIndex` exists in `acc`
            if (!acc[pageIndex]) {
              acc[pageIndex] = { pageIndex, fields: {} };
            }

            if (fieldName && Array.isArray(rows)) {
              if (!acc[pageIndex].fields[fieldName]) {
                acc[pageIndex].fields[fieldName] = [];
              }

              acc[pageIndex].fields[fieldName] = [
                ...acc[pageIndex].fields[fieldName],
                ...rows.map((row: any) => {
                  const rowData: any = {};

                  for (const key in row) {
                    if (key !== "id" && row.hasOwnProperty(key)) {
                      rowData[key] = row[key];
                    }
                  }

                  return rowData;
                }),
              ];
            }

            return acc;
          },
          []
        );

        setTransformedData(groupedData);
      }
    }
  }, []);

  useEffect(() => {
    if (open && file) {
      getFile();
    }
  }, [open]);

  const handleOpenMail = () => {
    setIsMailOpen(true);
  };

  const handleCloseMail = () => {
    setIsMailOpen(false);
  };

  const handlePageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setInputValue(value);
    const page = parseInt(value, 10);
    if (!isNaN(page) && page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const goToNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
    setInputValue((prev) => (parseInt(prev, 10) + 1).toString());
  };

  const goToPreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
    setInputValue((prev) => (parseInt(prev, 10) - 1).toString());
  };

  const getFile = async () => {
    try {
      if (file?._id) {
        setFetchFileLoader(true);
        const response: any = await appRequest("filesystem", "get", {
          id: file._id,
        });
        if (response) {
          if (response?.error) {
          } else {
            let buffer =
              typeof response === "string" ? JSON.parse(response) : response;
            buffer = new Uint8Array(buffer);

            const fileURL = URL.createObjectURL(
              new Blob([buffer], { type: file.metadata.contentType })
            );
            setSample({
              url: fileURL,
              file: file,
              type: file.metadata.contentType,
              buffer: buffer,
            });
          }
        }
      }
    } catch (error: any) {
      toastNotify({
        title: "Error",
        message: error.message,
        type: "error",
      });
    } finally {
      setFetchFileLoader(false);
    }
  };

  let width = "98vw";

  const handleModalWheel = (event: React.WheelEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  const handleSaveFromParent = () => {
    if (tableRef.current) {
      const savedData = tableRef.current.save;
      setFinalResults(savedData);
      return savedData;
    }
  };

  const saveDocument = async () => {
    let savedData = handleSaveFromParent();
    setOpenSaveModal({
      open: true,
      data: {
        id: selectedRows[0]?._id,
        documentId: selectedRows[0]?.documentId,
        values: savedData,
      },
    });
  };

  return (
    <>
      <Drawer isOpen={open} onClose={close} size="full">
        <DrawerOverlay bg="rgba(0, 0, 0, 0.2)" />
        <DrawerContent
          // position="fixed"
          // right={isOpen ? "0" : `-${width}`}
          // top="0"
          // height="100vh"
          // width={viewerWidth ? width : "100vw"}
          // animation={`${
          //   isOpen ? "slideIn" : "slideOut"
          // } 0.8s ease-in-out forwards`}
          style={{ width: "98vw" }}
        >
          <DrawerHeader
            fontSize={{ base: "md", lg: "lg" }}
            color="teal.300"
            fontWeight="700"
            p=".6rem"
            ml="1rem"
          >
            Document
          </DrawerHeader>
          <DrawerCloseButton />
          <DrawerBody
            px={{ base: ".5rem", lg: "1.5rem" }}
            py=".2rem"
            overflowY="auto"
            className="customScrollBar"
            mb={{ base: "1rem", lg: "unset" }}
          >
            <Box
              display={{ base: "grid", lg: "flex" }}
              flexDirection={{ base: "column", lg: "row" }}
              gap={{ base: 1, lg: 6 }}
              h="100%"
            >
              {fetchFileLoader ? (
                <Box
                  h={{ base: "30vh", md: "40vh", lg: "80vh" }}
                  mb="1rem"
                  w="100%"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Spinner
                    size="xl"
                    thickness="4px"
                    speed="0.65s"
                    color="teal.400"
                  />
                </Box>
              ) : (
                <Box
                  h={{ base: "30vh", md: "40vh", lg: "85vh" }}
                  w={{ lg: "40vw" }}
                >
                  <FileViewer sample={sample} />
                </Box>
              )}
              <Box>
                {transformedData && (
                  <Box
                    h={!isDisabled ? "85vh" : "85vh"}
                    w={{ base: "100%", lg: "55vw" }}
                    p={{ base: "0.8rem", lg: "1rem" }}
                    overflowY="auto"
                    className="customScrollBar"
                    onWheel={handleModalWheel}
                    border="1px solid"
                    borderColor="teal.500"
                    borderRadius="md"
                    boxShadow="sm"
                    mb={4}
                    background="white"
                  >
                    <Flex
                      justifyContent="space-between"
                      alignItems="center"
                      display="none"
                    >
                      <Flex justifyContent="center" mb={5}>
                        <Text fontSize="sm" color="teal.600">
                          Page {currentPage} of {totalPages}
                        </Text>
                        <Text>Total No of Data : ${currentTotalDataCount}</Text>
                      </Flex>
                      <HStack spacing={4} mb={4} justify="flex-start">
                        {workFlowData &&
                          workFlowData?.table[0]?.action?.downloadExcel &&
                          accountDetails?.userPermission?.includes(
                            "download"
                          ) &&
                          name === "Approved" && (
                            <Button
                              onClick={() => {
                                handleDownloadExcel(
                                  transformedData,
                                  values,
                                  toastNotify,
                                  ["download"],
                                  fieldName,
                                  fileData,
                                  setFileData,
                                  setFinalResults
                                );
                                // exportToExcel(handleSaveAllPages())
                              }}
                              colorScheme="teal"
                              variant="solid"
                              size="sm"
                              fontWeight="medium"
                              _hover={{ bg: "teal.600", color: "white" }}
                              leftIcon={<FiDownload />}
                            >
                              <Tooltip
                                label="Download all pages as Excel"
                                aria-label="Download Tooltip"
                                hasArrow
                              >
                                Download
                              </Tooltip>
                            </Button>
                          )}
                        {workFlowData &&
                          accountDetails?.userPermission?.includes("mail") &&
                          name === "Approved" && (
                            <Button
                              onClick={() => {
                                // handleDownloadExcel(
                                //   transformedData,
                                //   values,
                                //   toastNotify,
                                //   sendMail,
                                //   fieldName,
                                //   fileData,
                                //   setFileData,
                                //   setFinalResults
                                // );
                                handleOpenMail();
                                // exportToExcel(handleSaveAllPages())
                              }}
                              colorScheme="teal"
                              variant="solid"
                              size="sm"
                              fontWeight="medium"
                              _hover={{ bg: "teal.600", color: "white" }}
                              leftIcon={<MdEmail />}
                            >
                              <Tooltip
                                label="Send mail with attachment."
                                aria-label="Send Mail"
                                hasArrow
                              >
                                Send Mail
                              </Tooltip>
                            </Button>
                          )}
                        <Button
                          onClick={goToPreviousPage}
                          isDisabled={currentPage === 1}
                          colorScheme="teal"
                          variant="outline"
                          size="sm"
                          fontWeight="medium"
                          _hover={{ bg: "teal.50" }}
                        >
                          <FiChevronLeft size={20} />
                        </Button>
                        <Input
                          type="number"
                          value={inputValue}
                          onChange={handlePageChange}
                          placeholder={`Enter page (1-${totalPages})`}
                          w="60px"
                          textAlign="center"
                          fontSize="sm"
                          borderColor="teal.400"
                          focusBorderColor="teal.500"
                          size="sm"
                          mb={0}
                        />

                        <Button
                          onClick={goToNextPage}
                          isDisabled={currentPage === totalPages}
                          colorScheme="teal"
                          variant="outline"
                          size="sm"
                          fontWeight="medium"
                          _hover={{ bg: "teal.50" }}
                        >
                          <FiChevronRight size={20} />
                        </Button>
                      </HStack>
                    </Flex>
                    <DynamicTableForm
                      pages={transformedData}
                      setCurrentTotalDataCount={setCurrentTotalDataCount}
                      ref={tableRef}
                      name={name}
                      workFlowData={workFlowData}
                      accountDetails={accountDetails}
                    />
                    {/* {transformedData[currentPage - 1] ? (
                      <DynamicForm
                        data={transformedData[currentPage - 1]}
                        onDataChange={handleFormDataChange}
                        name={name}
                        setDeletedDataIndex={setDeletedDataIndex}
                      />
                    ) : (
                      <Text fontSize="md" color="gray.600" textAlign="center">
                        No data available for this page.
                      </Text>
                    )} */}
                  </Box>
                )}
              </Box>
            </Box>
          </DrawerBody>
          {!isDisabled &&
            accountDetails.role !== "admin" &&
            name === "Pending Approval" &&
            ["approver", "uploader"].includes(accountDetails?.role) && (
              <ModalFooter p="0.5rem">
                <Flex>
                  {!isDisabled &&
                    accountDetails.role !== "admin" &&
                    name === "Pending Approval" &&
                    ["approver", "uploader"].includes(accountDetails?.role) && (
                      <Box>
                        <Button
                          onClick={() => {
                            saveDocument();
                          }}
                          fontSize="sm"
                          bg="green.500"
                          color="white"
                          _hover={{ bg: "green.600" }}
                          mr="1rem"
                          w="100px"
                        >
                          Save
                        </Button>
                        <Button
                          onClick={() => {
                            handleSaveFromParent();
                            // handleDocUpdate('approved',level,id)
                            // handleSaveAllPages(
                            //   transformedData,
                            //   values,
                            //   setFinalResults,
                            //   deletedDataIndex
                            // );
                            setCommentModel({
                              open: true,
                              selectedStatus: "approved",
                              comment: "",
                              isMulti: false,
                            });
                          }}
                          fontSize="sm"
                          bg="green.500"
                          color="white"
                          _hover={{ bg: "green.600" }}
                          mr="1rem"
                          w="100px"
                        >
                          Accept
                        </Button>
                        <Button
                          onClick={() => {
                            handleSaveFromParent();
                            setCommentModel({
                              open: true,
                              selectedStatus: "rejected",
                              comment: "",
                              isMulti: false,
                            });
                          }}
                          bg="red.500"
                          _hover={{ bg: "red.600" }}
                          color="white"
                          w="100px"
                          mr="14px"
                        >
                          Reject
                        </Button>
                      </Box>
                    )}{" "}
                </Flex>
              </ModalFooter>
            )}
        </DrawerContent>
        <style>
          {`
          @keyframes slideIn {
            from {
              right: -${width};
            }
            to {
              right: 0;
            }
          }
          @keyframes slideOut {
            from {
              right: 0;
            }
            to {
              right: -${width};
            }
          }
          `}
        </style>
        <CommentDrawer
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          editedValues={finalResults}
          setCommentModel={setCommentModel}
          handleGet={getData}
          view={true}
          isOpen={commentModel.open}
          width={width}
          onClose={() => {
            setCommentModel({
              open: false,
              selectedStatus: "approved",
              comment: "",
              isMulti: false,
            });
            close();
          }}
          handleClose={() => {
            setCommentModel({
              open: false,
              selectedStatus: "approved",
              comment: "",
              isMulti: false,
            });
            close();
          }}
          selectedFile={file}
        />
        <MailModal
          fileData={fileData}
          isOpen={isMailOpen}
          onClose={handleCloseMail}
          fieldName={fieldName}
          setFieldName={setFieldName}
          transformedData={transformedData}
          values={values}
          setFileData={setFileData}
          sendMail={["mail"]}
          // data={data}
        />
      </Drawer>
      <SaveDocumentModal
        data={openSaveModal.data}
        handleGet={getData}
        isOpen={openSaveModal.open}
        onClose={() => setOpenSaveModal({ data: null, open: false })}
      />
    </>
  );
};

export default CurbayMedicineCustomModal;
